import script from "./TableAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableAvatar.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QAvatar});
